<template src="./template.html" />
<script>
import { Promise } from 'q'
import Inputs from 'src/components/fields-generator/index.js'
import { firebase } from '@firebase/app'
import Moment from 'moment'
import { checkPermission, getPermission } from 'naf-acl'
import NumberUtils from 'utils/NumberUtils'
export default {
  name: 'LandingPage',
  components: Inputs,
  props: {
    title: {
      type: String,
      default: () => ''
    },
    queryConditions: {
      type: Object,
      default: () => undefined
    },
    baseData: {
      type: [Object, Array],
      default: () => undefined
    },
    backLink: {
      type: String,
      default: () => '/'
    },
    routeDetailName: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      default: () => []
    },
    idFieldName: {
      type: String,
      default: ''
    },
    canCreate: {
      type: Boolean,
      default: () => undefined
    },
    canCopy: {
      type: Boolean,
      default: () => undefined
    },
    canDelete: {
      type: Boolean,
      default: () => undefined
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    useOneMeta: {
      type: Boolean,
      default: () => false
    },
  },
  data () {
    return {
      data: [],
      isLoading: true,
      confirmDeleteDialog: false,
      isCopying: false,
      isDeleting: false,
      selectedRow: {},
      rowIndex: 0,
      privateQueryCondition: this.queryConditions,
      res: [],
      privatePagination: this.tableConfig.pagination,
      fetchedPage: 1,
      cachingData: [],
      NumberUtils
    }
  },
  async mounted () {
    this.showLoading()
    this.isLoading = true
    await this.fetchData()
    this.isLoading = false
    this.hideLoading()
    this.$on('fetchData', this.fetchData)
  },
  methods: {
    assignBaseData() {
      if(this.baseData) {
        this.data = this.baseData
        this.data.forEach((item, index) => item.position = index)
        this.cacheData(this.data)
      }
    },
    async fetchData () {
      this.isLoading = true
      if(this.privateQueryCondition) {
        await this.$query(this.privateQueryCondition.ref, this.privateQueryCondition.filter, this.privateQueryCondition.order,
        this.privateQueryCondition.limit, this.privateQueryCondition.after, this.privateQueryCondition.returnSnapshot).then(res => {
          if(res.error) throw new Error(res.error.message)
          this.data = Array.isArray(res.data) ? res.data : res[this.privateQueryCondition.fieldName]
          this.data.forEach((item, index) => item.position = index)
          this.res = res
          this.cacheData(this.data)
        }).catch(e => {
          console.log(e)
          this.$q.notify({
            message: `${e}`,
            color: 'red',
            icon: 'error'
          })
        })
      }
      this.isLoading = false
    },
    cacheData (newData) {
      if(this.R.isEmpty(this.cachingData)) {
        this.cachingData = this.cachingData.concat(newData)
      }
    },
    routeDetail (id) {
      this.showLoading()
      this.$emit('edit-event', id)
      this.hideLoading()
    },
    async submitDelete () {
      let vm = this
      vm.showLoading()
      this.isLoading = true
      this.isDeleting = true
      let result = new Promise((resolve, reject) => this.$emit('delete-event', this.selectedRow, resolve, reject))
      try {
        await result.then(() => {
          vm.$q.notify({
            message: 'Đã xóa thành công',
            color: 'black',
            icon: 'check'
          })
          vm.fetchData()
        })
      } catch (error) {
        vm.$q.notify({
          message: error.toString(),
          color: 'red',
          icon: 'error'
        })
      }
      this.isLoading = false
      this.isDeleting = false
      vm.hideLoading()
    },
    showLoading () {
      if (this.$root.$children[0].$refs['top-loadding-bar']) this.$root.$children[0].$refs['top-loadding-bar'].start()
    },
    hideLoading () {
      let vm = this
      vm.$nextTick(() => {
        if (vm.$root.$children[0].$refs['top-loadding-bar']) vm.$root.$children[0].$refs['top-loadding-bar'].stop()
      })
    },
    addButtonClick () {
      this.$emit('add-button-click')
    },
    copyButtonClick (id) {
      this.isCopying = true
      this.showLoading()
      this.$emit('copy-event', id)
      this.hideLoading()
      this.isCopying = false
    },
    // eslint-disable-next-line no-unused-vars
    formatString (string, $this, row, col) {
      // eslint-disable-next-line no-unused-vars
      let Timestamp = firebase.firestore.Timestamp
      // eslint-disable-next-line no-unused-vars
      let moment = Moment
      // eslint-disable-next-line no-unused-vars
      let NumberUtils = this.NumberUtils
      // eslint-disable-next-line no-eval
      return eval(string)
    },
    checkDelete(item) {
      if(!this.R.isNil(this.canDelete)) return this.canDelete
      let perm = this.useOneMeta ? this.getPermission(this.R.path(['permission'], this.res.metaData)) : this.getPermission(this.R.path(['metaData', 'permission'], item))
      return perm.indexOf('write') !== -1 || perm.indexOf('delete') !== -1
    },
    checkPermission,
    getPermission,
    sortMethod(rows, sortBy, desc) {
      let rowsCopy = this.R.clone(rows)
      let vm = this
      let cols = vm.headers
      let found = vm._.find(cols, item => item.name === sortBy)
      let sortResult = rowsCopy.sort((a, b) => {
        let x = desc ? b[sortBy] : a[sortBy]
        let y = desc ? a[sortBy] : b[sortBy]
        if(found && found.sort) {
          return found.sort(x, y)
        }
        if(typeof x === 'string' && typeof y === 'string') {
          return x.localeCompare(y)
        }
        return x > y ? 1 : x < y ? -1 : 0
      })
      sortResult.forEach((element, index) => {
        element.position = index
      })
      return sortResult
    },
    scrollToTop() {
      try {
        this.$refs['scrollToTop'].$el.click()
      // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    resetPaginationState() {
      this.cachingData = []
      this.fetchedPage = 1
      this.privatePagination.rowsNumber = this.tableConfig.pagination.rowsNumber
    },
    fetchSortBy(sortBy, desc) {
      if(sortBy !== this.privateQueryCondition.order[0] || (desc ? 'desc' : 'asc') !== this.privateQueryCondition.order[1]) {
        this.privateQueryCondition.after = null
        this.privateQueryCondition.order = sortBy ? [sortBy, desc ? 'desc' : 'asc'] : this.R.clone(this.queryConditions.order)
        this.resetPaginationState()
        return this.fetchData()
      }
      return true
    },
    fetchLimit() {
      this.resetPaginationState()
      return this.fetchData()
    },
    async handlePagination(props) {
      this.scrollToTop()
      if(!props.pagination.sortBy) {
        props.pagination.sortBy = null
        await this.fetchSortBy(this.queryConditions.order[0], props.pagination.descending)
      } else {
        await this.fetchSortBy(props.pagination.sortBy, props.pagination.descending)
      }
      if(props.pagination.rowsPerPage !== this.privateQueryCondition.limit) {
        this.privateQueryCondition.limit = props.pagination.rowsPerPage
        this.fetchLimit()
      }
      if(props.pagination.page > this.fetchedPage) {
        let oldRecords = this._.cloneDeep(this.cachingData)
        this.privateQueryCondition.after = this.res.docsSnapshot.docs[this.res.docsSnapshot.size - 1]
        await this.fetchData()
        if(this.data.length > 0 && props.pagination.page > this.fetchedPage) {
          oldRecords = oldRecords.concat(this.data)
          this.cachingData = oldRecords
          this.fetchedPage = props.pagination.page
          this.privatePagination.rowsNumber+= oldRecords.length
        } else {
          this.privatePagination.rowsNumber = oldRecords.length
          this.data = this.cachingData.slice((props.pagination.page - 1) * props.pagination.rowsPerPage, props.pagination.page * props.pagination.rowsPerPage)
        }
      } else {
        this.data = this.cachingData.slice((props.pagination.page - 1) * props.pagination.rowsPerPage, props.pagination.page * props.pagination.rowsPerPage)
      }
      this.privatePagination.rowsPerPage = props.pagination.rowsPerPage
      this.privatePagination.page = props.pagination.page
      this.privatePagination.sortBy = props.pagination.sortBy
      this.privatePagination.descending = props.pagination.descending
    },
    uniqBy(a, key) {
      let seen = new Set();
      return a.filter(item => {
        let k = item[key];
        return seen.has(k) ? false : seen.add(k);
      });
    }
  },
  watch: {
    queryConditions: {
      handler: function(newValue) {
        this.privateQueryConditions = newValue
      },
      deep: true
    },
    baseData: {
      handler: function(newValue) {
        if(newValue) {
          this.assignBaseData()
        }
      }
    }
  }
}
</script>

